










import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import SignUpComponent from "@/components/SignUpComponent";

export default defineComponent({
  name: "PageSignUp",
  components: { BasePage, SignUpComponent },
});
